import { MosaicWall, TextMosaic, TextMosaicDto, getLoginData, makeConcealable } from '@ami/react/core';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { ProductGroupTypes } from '../../products/productGroup';
import QuoteProductDetail from '../../quotes/entities/quoteProductDetail';
import { QuoteProductDto } from '../../quotes/otherQuoteEntities';
import { Quote } from '../../quotes/quote';
import { QuoteProductConfiguration } from '../../quotes/quoteProductConfiguration';
import ProductBucketQuoteProductSelectionComponent from '../../quotes/step3/ProductBucketQuoteProductSelectionComponent';
import ProductExistingBucketComponent from '../../quotes/step3/ProductExistingBucketComponent';
import ProductThumbSelectionWarnings from '../../quotes/step3/ProductThumbSelectionWarnings';
import ThumbBucketLocationType from '../entities/thumbBucketLocationType';

const DivDoYouHaveTheSpecificationsForTheBucketAvailableNow = makeConcealable(
  (props) => (
    <div className="row justify-content-center text-center mb-2">
      <h5>Do you have the specifications for the bucket available now?</h5>
    </div>
  )
);

class ProductThumbSelectionComponent extends React.Component {
  static propTypes = {
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
    onUpdate: PropTypes.func.isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration)
      .isRequired,
    quote: PropTypes.instanceOf(Quote).isRequired,
    quoteProductDto: PropTypes.instanceOf(QuoteProductDto).isRequired,
    onQuoteProductDtoChange: PropTypes.func.isRequired,
    isAmiPriceLookupMode: PropTypes.bool.isRequired,
    onFinishBucketConfiguration: PropTypes.func.isRequired,
    onChangeBucketDetails: PropTypes.func.isRequired,
  };

  state = {
    agreeTerms: false,
  };

  async componentDidMount() {
    this.setAmiPriceLookupMode();
  }

  setAmiPriceLookupMode() {
    const { isAmiPriceLookupMode, entity } = this.props;
    if (isAmiPriceLookupMode) {
      const loginData = getLoginData();
      if (loginData) {
        entity.bucketLocation = ThumbBucketLocationType.ExistingQuote;
        entity.existingBucketSpecsAvailable = false;
        entity.existingBucketSpecsNotAvailableAcknowledgedByUserId =
          loginData.userData.id;
        entity.existingBucketSpecsNotAvailableAcknowledgedByUserName =
          loginData.userData.name;
        entity.existingBucketSpecsNotAvailableAcknowledgedDate = moment();
        entity.isEdit = false;

        this.props.onUpdate(new QuoteProductDetail({ ...entity }));
      }
    }
  }

  onUpdateEntity(property, value) {
    var entity = this.props.entity;
    entity[property] = value;
    this.props.onUpdate(new QuoteProductDetail({ ...entity }));
  }

  getProductFiltered = () => {
    const { quote, quoteProductConfiguration } = this.props;
    const { products } = quote;
    var productGroupIds = products.map((x) => x.productGroupId);
    var productGroups = quoteProductConfiguration.productGroups.filter((x) =>
      productGroupIds.includes(x.id)
    );
    var productGroupsFiltered = productGroups.filter((x) =>
      [
        ProductGroupTypes.StandardDiggingBucket.id,
        ProductGroupTypes.RecessedDiggingBucket.id,
        ProductGroupTypes.SpadeToothDiggingBucket.id,
        ProductGroupTypes.SpadeToothRecessedDiggingBucket.id,
        ProductGroupTypes.DitchingBucket.id,
        ProductGroupTypes.TiltDitchingBucket.id,
      ].includes(x.type)
    );
    var productGroupsFilteredIds = productGroupsFiltered.map((x) => x.id);
    return products.filter((x) =>
      productGroupsFilteredIds.includes(x.productGroupId)
    );
  };

  onBucketLocationChange(bucketLocation) {
    var entity = this.props.entity;
    entity.bucketLocation = bucketLocation;
    this.onExistingBucketSpecsAvailableChange(null);
  }

  onExistingBucketSpecsAvailableChange(existingBucketSpecsAvailable) {
    const { isAmiPriceLookupMode } = this.props;
    var entity = this.props.entity;

    if (isAmiPriceLookupMode && existingBucketSpecsAvailable == false) {
      this.setAmiPriceLookupMode();
    } else {
      entity.existingBucketSpecsAvailable = existingBucketSpecsAvailable;
      entity.bucketQuoteProductId = null;
      entity.existingBucket = null;
      entity.existingBucketSpecsNotAvailableAcknowledgedByUserId = null;
      entity.existingBucketSpecsNotAvailableAcknowledgedByUserName = null;
      entity.existingBucketSpecsNotAvailableAcknowledgedDate = null;
      this.setState({ agreeTerms: false });
    }

    this.props.onUpdate(new QuoteProductDetail({ ...entity }));
    this.props.onQuoteProductDtoChange({ productId: null });
  }

  onChangeBucketDetails(isEdit) {
    var entity = this.props.entity;
    entity.isEdit = isEdit;
    this.props.onUpdate(new QuoteProductDetail({ ...entity }));
    this.props.onQuoteProductDtoChange({ productId: null });
    this.props.onChangeBucketDetails(isEdit)
  }

  render() {
    const {
      entity,
      quoteProductConfiguration,
      onUpdate,
      quote,
      quoteProductDto,
      isAmiPriceLookupMode,
      onFinishBucketConfiguration
    } = this.props;
    const { agreeTerms } = this.state;
    const products = this.getProductFiltered();
    const noBuckets =
      entity.bucketLocation === ThumbBucketLocationType.SameQuote &&
      (!products || products.length === 0);
    const noHaveSpecificationForBucket =
      entity.bucketLocation === ThumbBucketLocationType.ExistingQuote &&
      entity.existingBucketSpecsAvailable === false;
    return (
      <Fragment>
        {!isAmiPriceLookupMode && (
          <div className="row justify-content-center text-center mb-2">
            <h5>Will the thumb be used with a bucket on this quote?</h5>
          </div>
        )}
        {!isAmiPriceLookupMode && entity.bucketLocation === null && (
          <div className="row justify-content-center text-center">
            <div className="banner-container">
              <div className="alert alert-success justify-content-center">
                <i className="fa fa-info-circle fa-lg text-success me-1"></i>
                Faster lead times are available if you get an AMI bucket with this thumb
              </div>
            </div>
          </div>
        )}
        {!isAmiPriceLookupMode && (
          <div className="row text-center mt-1">
            <MosaicWall
              childrenContainerClassName="row justify-content-center"
              placeholder="Select a option.."
            >
              <TextMosaic
                data={
                  new TextMosaicDto({
                    label: <div>Yes</div>,
                    selected:
                      entity.bucketLocation ===
                      ThumbBucketLocationType.SameQuote,
                    disabled: !entity.isEdit,
                  })
                }
                onClick={() =>
                  this.onBucketLocationChange(ThumbBucketLocationType.SameQuote)
                }
                widthColumns={4}
              />
              <TextMosaic
                data={
                  new TextMosaicDto({
                    label: <div>No</div>,
                    selected:
                      entity.bucketLocation ===
                      ThumbBucketLocationType.ExistingQuote,
                    disabled: !entity.isEdit,
                  })
                }
                onClick={() =>
                  this.onBucketLocationChange(
                    ThumbBucketLocationType.ExistingQuote
                  )
                }
                widthColumns={4}
              />
            </MosaicWall>
          </div>
        )}
        {
          <DivDoYouHaveTheSpecificationsForTheBucketAvailableNow
            show={
              entity.bucketLocation === ThumbBucketLocationType.ExistingQuote
            }
            scrollOnShow={true}
          />
        }
        {entity.bucketLocation === ThumbBucketLocationType.ExistingQuote && (
          <div className="row text-center mt-1">
            <MosaicWall
              childrenContainerClassName="row justify-content-center"
              placeholder="Select a option.."
            >
              <TextMosaic
                data={
                  new TextMosaicDto({
                    label: <div>Yes</div>,
                    selected: entity.existingBucketSpecsAvailable,
                    disabled: !entity.isEdit,
                  })
                }
                onClick={() => this.onExistingBucketSpecsAvailableChange(true)}
                widthColumns={4}
              />
              <TextMosaic
                data={
                  new TextMosaicDto({
                    label: <div>No</div>,
                    selected: entity.existingBucketSpecsAvailable === false,
                    disabled: !entity.isEdit,
                  })
                }
                onClick={() => this.onExistingBucketSpecsAvailableChange(false)}
                widthColumns={4}
              />
            </MosaicWall>
          </div>
        )}
        <ProductThumbSelectionWarnings
          show={noBuckets || noHaveSpecificationForBucket}
          scrollOnShow={true}
          noBuckets={noBuckets}
          noHaveSpecificationForBucket={noHaveSpecificationForBucket}
          agreeTerms={agreeTerms}
          onAgreeTerms={(agreeTerms) => this.setState({ agreeTerms })}
          entity={entity}
          isAmiPriceLookupMode={isAmiPriceLookupMode}
        />
        <ProductBucketQuoteProductSelectionComponent
          show={
            entity.bucketLocation === ThumbBucketLocationType.SameQuote &&
            !noBuckets
          }
          scrollOnShow={true}
          entity={entity}
          onUpdate={(detail) => onUpdate(detail)}
          quoteProductConfiguration={quoteProductConfiguration}
          products={products}
          onFinishBucketConfiguration={(completed) => {
            onFinishBucketConfiguration(completed);
          }}
        />
        {entity.bucketLocation === ThumbBucketLocationType.ExistingQuote && (
          <ProductExistingBucketComponent
            entity={entity}
            onUpdate={(detail) => onUpdate(detail)}
            agreeTerms={agreeTerms}
            quote={quote}
            isEdit={entity.isEdit}
            onChangeBucketDetails={(isEdit) =>
              this.onChangeBucketDetails(isEdit)
            }
            quoteProductDto={quoteProductDto}
            onFinishBucketConfiguration={(completed) => {
              onFinishBucketConfiguration(completed);
            }}
          />
        )}
      </Fragment>
    );
  }
}

export default ProductThumbSelectionComponent;
